import React, {Fragment, PureComponent} from 'react';
import autobind from 'autobind-decorator';

import {ObjectUtils} from "../../../../Utils";

export const SurveyFormInputEnhance = ((ComposedComponent) => class SurveyFormInputEnhance extends PureComponent {
    @autobind
    setValidationStatusError(message) {
        this._setValidationStatus(message);
    }

    @autobind
    markValidationStatusValid() {
        this._setValidationStatus(null);
    }

    getConservationAction() {
        return this.props.ConservationAction;
    }

    @autobind
    getQuestion() {
        return this.props.Question;
    }

    @autobind
    getAnswer() {
        const conservationAction = this.getConservationAction();
        const question = this.getQuestion();

        if(conservationAction && question) {
            let answer = this.props.Answer;
            if(answer) {
                return ObjectUtils.Clone(answer);
            } else {
                return {
                    surveyQuestionId: question.surveyQuestionId,
                    conservationActionId: conservationAction.conservationActionId
                };
            }
        }

        return null;
    }


    @autobind
    getOptions() {
        const { SurveyQuestionDataType } = this.props;

        if(SurveyQuestionDataType) {
            if(SurveyQuestionDataType.options) {
                if(ObjectUtils.IsString(SurveyQuestionDataType.options)) {
                    return JSON.parse(SurveyQuestionDataType.options);
                } else {
                    return SurveyQuestionDataType.options;
                }
            } else {
                return {};
            }
        }

        return null;
    }

    @autobind
    change(updateLogic) {
        const { OnChange } = this.props;

        if(OnChange) {
            const answer = this.getAnswer();

            if(answer) {
                OnChange(updateLogic(answer));
            }
        }
    }

    //private
    @autobind
    _setValidationStatus(message) {
        const { Question, OnValidation } = this.props;

        if(OnValidation) {
            OnValidation(Question.surveyQuestionId, message);
        }
    }

    render() {
        return <Fragment>
            <ComposedComponent
                {...this.props}
                SurveyFormInput={{
                    SetValidationStatusError: this.setValidationStatusError,
                    MarkValidationStatusValid: this.markValidationStatusValid,
                    GetOptions: this.getOptions,
                    GetQuestion: this.getQuestion,
                    GetAnswer: this.getAnswer,
                    Change: this.change
                }}
            />
            {
                this.props.Validation != null ?
                    <p className="sb-survey-validation-error">{this.props.Validation}</p>:
                    null
            }
        </Fragment>;
    }
});
